__webpack_require__.p = "//img0.didiglobal.com/static/manhattan_global_static/freya-kyc/landing-page/";